const widget = {
    waitForWidgetConstructor() {
        const WidgetConstructor = this.getWidgetConstructor()

        if (WidgetConstructor) {
            return true
        }

        if (this.initAttempts >= this.config.maxInitAttempts) {
            if (!this.widgetInitWarned) {
                console.warn('FriendlyCaptcha widget script not available in time.')
                this.widgetInitWarned = true
            }

            if (!this.buttonInitiallyDisabled) {
                this.buttonElement.disabled = false
            }

            return false
        }

        this.initAttempts += 1
        window.setTimeout(() => this.initWidget(), this.config.initRetryDelay)

        return false
    },

    createWidget() {
        if (this.isV2Api()) {
            this.createV2Widget()
            return
        }

        const WidgetConstructor = this.getWidgetConstructor()
        const widgetOptions = {
            startMode: this.config.startMode,
            sitekey: this.config.sitekey,
            puzzleEndpoint: this.config.puzzleEndpoint,
            language: this.config.lang,
            skipStyleInjection: true
        }

        try {
            this.widget = new WidgetConstructor(this.widgetElement, widgetOptions)
            this.widgetInitialized = true
            this.isStarted = false
        } catch (error) {
            console.error('FriendlyCaptcha widget initialization failed:', error)

            if (!this.buttonInitiallyDisabled) {
                this.buttonElement.disabled = false
            }
        }
    },

    createV2Widget() {
        try {
            if (this.widgetElement.frcWidget) {
                this.widget = this.widgetElement.frcWidget
            } else {
                const widgets = window.frcaptcha.attach(this.widgetElement)
                this.widget = widgets?.[0] || this.widgetElement.frcWidget || null
            }

            if (!this.widget) {
                throw new Error('Friendly Captcha v2 widget was not returned by the SDK.')
            }

            this.widgetInitialized = true
            this.isStarted = false
        } catch (error) {
            console.error('FriendlyCaptcha v2 widget initialization failed:', error)

            if (!this.buttonInitiallyDisabled) {
                this.buttonElement.disabled = false
            }
        }
    },

    setupDoneCallback() {
        if (this.isV2Api()) {
            this.setupV2DoneCallback()
            return
        }

        window[this.config.callback] = (solutionValue) => {
            this.handleCompletedSolution(solutionValue)
        }
    },

    setupV2DoneCallback() {
        this.boundHandlers = {
            ...this.boundHandlers,
            v2StateChange: (event) => {
                const detail = event.detail || {}

                if (detail.state === 'completed') {
                    this.handleCompletedSolution(detail.response || this.widget?.getResponse?.() || '')
                    return
                }

                if (detail.state === 'error') {
                    console.error(detail.error)
                    this.buttonElement.disabled = false
                    return
                }

                this.buttonElement.disabled = true
            }
        }

        this.widgetElement.addEventListener('frc:widget.statechange', this.boundHandlers.v2StateChange)
    },

    handleCompletedSolution(solutionValue) {
        this.form.friendlyCaptchaSolution = solutionValue
        this.updateHiddenSolution(solutionValue)
        this.buttonElement.disabled = false
        this.detachFormGate()

        if (typeof this.form.friendlyCaptchaResumeSubmit === 'function') {
            const resumeSubmit = this.form.friendlyCaptchaResumeSubmit
            this.form.friendlyCaptchaResumeSubmit = null
            resumeSubmit()
        } else {
            this.resumePendingSubmit()
        }

        this.changeWidgetVisibility(false, this.config.hideDuration)
    },

    getWidgetConstructor() {
        if (this.isV2Api()) {
            return window.frcaptcha || null
        }

        return window.friendlyChallenge?.WidgetInstance || window.WidgetInstance || null
    },

    isV2Api() {
        return this.config?.apiVersion === '2'
    },

    startWidgetIfNotAlreadyDone() {
        if (!this.isStarted && this.widget) {
            if (this.isV2Api()) {
                this.widget.start?.()
            } else {
                this.widget.start()
            }
            this.isStarted = true
        }
    },

    triggerWidgetStart() {
        this.startWidgetIfNotAlreadyDone()
        this.changeWidgetVisibility(true, this.config.showDuration)
    },

    resetWidget() {
        this.form.friendlyCaptchaSolution = ''
        this.updateHiddenSolution('')
        this.clearPendingSubmit()
        this.widget.reset?.()
        this.isStarted = false
    },

    changeWidgetVisibility(show, duration) {
        window.clearTimeout(this.visibilityTimer)
        this.visibilityTimer = window.setTimeout(() => {
            this.frcCaptchaIsVisible = show
        }, duration)
    }
}

export default widget
